import { useContext } from 'react';
import { pushFuncType, SnackbarContext } from '../../context/SnackbarContext';

export default function useSnackbar(): pushFuncType {
	const snackbarContext = useContext(SnackbarContext);

	return snackbarContext.push;
}
